import { FormElementTypeType } from "../../../../store/api/forms-api";

export const elementsRecord: Record<FormElementTypeType, string> = {
  input: 'Поле ввода',
  select: 'Список с одинарным выбором',
  'multi-select': 'Список с множественным выбором',
  datetime: 'Дата и время',
  datetimeRange: 'Диапазон даты и времени',
  switch: 'Переключатель',
  checkbox: 'Чекбокс',
};
